import { EtapaEstado, SistemaPrincipal } from 'src/types/workflow/cache'
import { HttpAxiosRequest } from '../httpAxiosBase'
import { EntityWithIdAndDescription } from 'src/types'
import {Sistema} from "../../pages/messages/types";

export const HttpCacheWorkflow = {
    getEnpoint: (url = '') => `cache/workflow${url}`,

    getSistemasPrincipales: (): Promise<SistemaPrincipal[]> => {
        return HttpAxiosRequest.get(HttpCacheWorkflow.getEnpoint('/sistemas/principales'))
    },

    getSistemasTipos: (): Promise<Sistema[]> => {
        return HttpAxiosRequest.get(HttpCacheWorkflow.getEnpoint('/sistemas/tipos'))
    },

    getSistemasPorSistemaPrincipal: (codSistemaPrincipal: number): Promise<EntityWithIdAndDescription[]> => {
        return HttpAxiosRequest.get(HttpCacheWorkflow.getEnpoint(`/sistemas/${codSistemaPrincipal}`))
    },

    getEtapaEstados: (): Promise<EtapaEstado[]> => {
        return HttpAxiosRequest.get(HttpCacheWorkflow.getEnpoint('/etapas/estados'))
    }
} as const
